<div class="app-row">
  <div class="app-column" style="align-items: center;">

    <div id="print-section" class="app-row print-section border" >
      <ng-content></ng-content>
    </div>

    <br>

    <button mat-raised-button [useExistingCss]="true" printSectionId="print-section" ngxPrint>
      <mat-icon>print</mat-icon>
      Print
    </button>

  </div>
</div>
